document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('gift-claim-checkbox');
  
  if (checkbox) {
    checkbox.addEventListener('change', function() {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            'Free gift claimed': this.checked ? 'Yes' : 'No'
          }
        })
      });
    });
  }
});
